import { Typography } from "antd";
import React from "react";

const { Title } = Typography;

export default function WidgetContainer({
  title,
  icon,
  color = "#4C7364",
  textColor = "white",
  overflow = "hidden",
  backgroundColor = "transparent",
  actions = [],
  ...props
}) {
  return (
    <div
      style={{
        border: `5px solid ${color}`,
        backgroundColor: `${backgroundColor}`,
        margin: 12,
        width: "calc(100% - 24px)",
        height: props.height || 90,
        boxShadow: "0px 0px 8px 2px rgba(102,101,102,1)",
      }}
    >
      <p
        style={{
          fontSize: 16,
          fontWeight: "normal",
          backgroundColor: `${color}`,
          color: `${textColor}`,
          margin: 0,
          padding: 6,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <span>
          {React.createElement(icon)}
          <span style={{ margin: "0 4px" }}></span>
          {title}
        </span>
        {actions.length > 0 ? (
          <span>
            {actions.map((item, index) =>
              React.cloneElement(item, {
                key: index,
                style: { marginRight: 4 },
              })
            )}
          </span>
        ) : null}
      </p>
      <div
        style={{
          padding: 12,
          width: "100%",
          height: `calc(${props.height} - 48px)`,
          overflow: overflow,
        }}
      >
        {props.children}
      </div>
    </div>
  );
}
